<template>
  <ConstructorioFacet v-if="facetData && !isDisabled" :is-light="isLight">
    <template #header>
      <button type="button" class="w-full px-4 py-2 text-left" @click="toggleFacet">
        <span class="flex justify-between items-center gap-x-2">
          <span class="uppercase break-words">
            {{ facetData.display_name }}
          </span>

          <span
            class="flex-none ml-2 my-2 h-4 w-8 flex items-center rounded-full border-2 border-transparent"
            :class="isActive ? 'bg-info-dark' : 'bg-gray-dark'"
          >
            <span
              class="h-3 w-3 bg-white rounded-full transform shadow"
              :class="[!isActive ? 'translate-x-0' : 'translate-x-4']"
            ></span>
          </span>
        </span>
      </button>
    </template>

    <template #default>
      <div></div>
    </template>
  </ConstructorioFacet>
</template>

<script setup lang="ts">
const { instance, updateSearch } = useConstructorInject()

defineProps<{
  isLight?: boolean
}>()

const facetData = computed(() => {
  return instance.state.value.facets.find((f) => f.name === 'isMadeInAmerica')
})

const values = computed(() => instance.getFacetValues(facetData.value?.name || ''))

const isActive = computed(() => {
  return values.value.includes('True')
})

const isDisabled = computed(() => {
  return !isActive.value && !facetData.value?.options.some(({ value }) => value === 'True')
})

function toggleFacet() {
  if (isActive.value) instance.clearFacets('isMadeInAmerica')
  else instance.addFacetValue('isMadeInAmerica', 'True')

  updateSearch()
}
</script>
